import { createAsyncThunk } from "@reduxjs/toolkit";
import apiInstance from "config/axiosInstance";

export const LoginUser = createAsyncThunk(
  "auth/LoginUser",
  async (body, { rejectWithValue }) => {
    const formData = new FormData();
    formData.append("email", body.email);
    formData.append("password", body.password);
    try {
      const response = await apiInstance.post("/login", formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ForgotPassword = createAsyncThunk(
  "auth/ForgotPassword",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("forget-password", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ResetPassword = createAsyncThunk(
  "auth/ResetPassword",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("reset-password", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const LogoutUser = createAsyncThunk(
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get("logout");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
